import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

export interface CashbackBonusTemplate {
  id: number;
  title: string;
  type?: string;
  status?: string;
  statusId?: number;
  image?: string;
}

export const getCashbackRewardBonuses = async (
  currency: string,
): Promise<CashbackBonusTemplate[]> => {
  console.log("CURRENCY", currency);

  const params = {
    type: "cashback",
    status: "activated",
    // currencyIds: [currency],
    limit: 100,
    offset: 0,
  };

  console.log("PARAMS", params);
  const response = (await instance.get(apiRoutes.bonusesList, {
    params,
  })) as {
    data?: { items?: CashbackBonusTemplate[] };
    items?: CashbackBonusTemplate[];
  };

  return response?.data?.items ?? response?.items ?? [];
};
